import React from 'react';
import styled from 'styled-components';
import Modal from 'library/components/modal';
import { bool, func, object, node, string } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';

const ModalBody = styled.div`
  flex: 1;
  box-shadow: 0px 4px 7px 2px rgba(0,0,0,0.2);
  outline: none;
  border-top: 10px #6acbe5 solid;
  border-radius: .3em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  word-break: break-word;
  padding: .9em 1.4em;
  background: #fff;
  transition: all .125s ease-in-out;
  height: 100vh;
  width: 100vw;
  margin: auto;
  ${props => props.padding != null && `padding: ${props.padding};`}

  @media (min-width: 1024px) {
    max-width: ${props => resolve(props.modalStyle, 'maxWidth', '850px')};
    min-width: ${props => resolve(props.modalStyle, 'minWidth', '400px')};
    min-height: ${props => resolve(props.modalStyle, 'minHeight', '600px')};
    height: ${props => resolve(props.modalStyle, 'height', '90%')};
    width: 100%;
  }
`;

const JourneyModalBody = ({active, toggleActive, modalStyle, children, padding}) => {
  return (
    <Modal active={active} onClose={() => toggleActive(!active)}>
      <ModalBody active={active} style={modalStyle} padding={padding}>
        {children}
      </ModalBody>
    </Modal>
  );
};

JourneyModalBody.propTypes = {
  active: bool,
  toggleActive: func,
  children: node,
  padding: string,
  modalStyle: object,
};

export default JourneyModalBody;
